import { Degree } from '@/models/Degree';
import { FilterSelectionState } from '../../../filters/selection/FilterSelectionState';
import { FilterKey } from '@studyportals/search-filters';
import { SearchOrganisationPresenter } from '../../../presenters/SearchOrganisationPresenter';
import { ISeoMetaDataInfo } from '../ISeoMetaDataInfo';
import { FilterOptions } from '@/filters/options/FilterOptions';
import { SeoMetaDataHandlerDefaultSort } from '../SeoMetaDataHandlerDefaultSort';

export class University extends SeoMetaDataHandlerDefaultSort {

	private readonly organisationPresenter: SearchOrganisationPresenter;

	public constructor(filterOptions: FilterOptions, organisationPresenter: SearchOrganisationPresenter) {
		super(filterOptions);

		this.organisationPresenter = organisationPresenter;
	}

	protected async canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean> {
		const singleOrganisationSelected = await this.singleSelectionFor(FilterKey.ORGANISATIONS, filterSelectionState);
		
		return singleOrganisationSelected;
	}

	protected async selfHandle(degree: Degree, filterSelectionState: FilterSelectionState): Promise<ISeoMetaDataInfo> {
		const portalName = degree.toPortalName();

		const idOfOrganisation = this.getFilterOptionValueBy(FilterKey.ORGANISATIONS, filterSelectionState);
		if (idOfOrganisation === null) {
			return this.createSeoInfoDefault(portalName);
		}
		return await this.createSeoInfoForOrganisation(idOfOrganisation, portalName);
	}

	private async createSeoInfoForOrganisation(idOfOrganisation: string, portalName: string): Promise<ISeoMetaDataInfo> {
		const university = await this.organisationPresenter.retrieve(idOfOrganisation);
		if (university === null) {
			return this.createSeoInfoDefault(portalName);
		}

		return this.createSeoInfo(university.name, portalName);
	}

	private createSeoInfoDefault(portalName: string): ISeoMetaDataInfo {
		const seoInfo: ISeoMetaDataInfo = {
			title: `Explore university | ${portalName}`,
			description: `Find out everything you need to know about the university with ${portalName}.`,
		};

		return seoInfo;
	}

	private async createSeoInfo(university: string, portal: string): Promise<ISeoMetaDataInfo> {
		const seoInfo = {
			title: `Explore ${university} | ${portal}`,
			description: `Find out everything you need to know about ${university} with ${portal}.`,
		};

		return Promise.resolve(seoInfo);
	}
}
